import {useEffect,useState} from 'react';
import {localLibraryRecord} from './localLibrary';

export default function useLocalLibrary(uid){
  const [state,setState]=useState(null);
  useEffect(()=>{
    if(!uid||!window.desktopAPI?.listLocalRecordings)return undefined;
    let alive=true,request=0;
    const reload=async()=>{
      const version=++request;
      try{const files=await window.desktopAPI.listLocalRecordings();
        if(alive&&version===request)setState({uid,records:files.map(localLibraryRecord).filter(Boolean),error:'',loading:false});
      }catch{if(alive&&version===request)setState({uid,records:[],error:'Local recordings could not be loaded. Check the recording folder in Settings.',loading:false});}
    };
    const visible=()=>{if(!document.hidden)void reload();};
    void reload();window.addEventListener('focus',reload);window.addEventListener('library-local-updated',reload);
    document.addEventListener('visibilitychange',visible);
    const stop=window.desktopAPI.onRecordSetupComplete?.(reload);
    return()=>{alive=false;request++;stop?.();window.removeEventListener('focus',reload);window.removeEventListener('library-local-updated',reload);document.removeEventListener('visibilitychange',visible);};
  },[uid]);
  return state?.uid===uid?state:{records:[],error:'',loading:!!uid&&!!window.desktopAPI?.listLocalRecordings};
}
